<template>
  <div id="app">
    <div v-if="$store.state.loading" class="">
      <div class="loading_cont_line">
        <div class="spinner">
          <div class="dot1"></div>
          <div class="dot2"></div>
        </div>
      </div>
    </div>
    <div v-else>
      <div style="padding: 20px; text-align: center" v-if="is_maintenance">
        En maintenance ...
      </div>
      <div style="padding: 20px; text-align: center" v-else-if="cgu_required">
        <a-card :bordered="false" style="max-width: 800px; margin: auto">
          <h2>Conditions générales d’utilisation</h2>
          <p>
            Dans le cadre de la mise en œuvre d’un traitement de données à
            caractère personnel, le règlement Européen sur la protection des
            données (RGPD) est venu renforcer les dispositions de la loi du 6
            janvier 1978 en responsabilisant désormais tous les acteurs traitant
            des données à caractère personnel.<br />
            Aussi il vous appartient, de prendre toute mesure susceptible de
            garantir un niveau de sécurité et de confidentialité des données
            mises à votre disposition.
          </p>
        </a-card>

        <div style="margin: 30px 200px">
          <a-checkbox v-model:checked="cgu_checked"
            >Accepter les conditions générales d’utilisation</a-checkbox
          >

          <div style="margin-top: 12px"></div>

          <a-button
            @click="setCGU"
            type="primary"
            shape="round"
            :disabled="!cgu_checked"
          >
            Valider
          </a-button>
        </div>
      </div>
      <div v-else>
        <TopMenu v-if="isLoged" />
        <MainMenu v-if="isLoged" />
        <router-view />
      </div>
    </div>
  </div>
</template> '

<script>
import MainMenu from "@/components/MainMenu.vue";
import TopMenu from "@/components/TopMenu.vue";

export default {
  name: "App",
  components: {
    TopMenu,
    MainMenu,
  },
  data: function () {
    return {
      rgpd_ck: false,
      is_maintenance: false,
      cgu_required: false,
      cgu_checked: false,
    };
  },
  whatch: {},
  methods: {
    setCGU() {
      this.$axios.post("/data/cgu").then((r) => {
        if (r.status === 201) {
          // this.$store.state.loading = true;
          this.cgu_required = false;
          // this.checkToken();
        }
      });
    },
    checkToken() {
      this.$axios
        .get("/auth/check_token")
        .then((r) => {
          if (r.status === 200) {
            if (
              this.$route.name === "login" ||
              this.$route.name === "createPassword"
            ) {
              this.$router.push("/");
            }

            this.$axios.get("/data/cgu").then((cgu) => {
              if (cgu.status === 202) {
                this.cgu_required = true;
              }
            });

            this.$store.state.isLoged = true;

            this.$store.dispatch("getCourtier").then((_) => {
              this.$store.state.loading = false;
            });
          }
        })
        .catch((r) => {
          localStorage.clear();

          if (this.$route.name === "createPassword") {
          } else {
            this.$router.push("/login");
          }
          this.$store.state.loading = false;

          this.is_maintenance = r.response.status === 503;
        });
    },
  },
  computed: {
    isLoged() {
      return this.$store.state.isLoged;
    },
  },
  async created() {
    this.checkToken();
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;700&display=swap");

body {
  font-family: "Montserrat", sans-serif !important;
  background-color: #f1f1f1 !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  /* overflow-x: inherit !important; */
}

.cpms_color {
  color: #b50f3c !important;
}
.ui.compact.table th {
  vertical-align: top;
}
.main_area {
  display: inline-block;
  vertical-align: top;
  padding: 100px 20px 0 80px;
  margin: 20px 0 20px 0;
  width: 100%;
}
.sub_menu {
  padding: 0 14px;
  background-color: white;
  height: 60px;
  -webkit-box-shadow: 0 0 3px #a4b1bf;
  box-shadow: 0 0 3px #a4b1bf;
  position: fixed;
  left: 60px;
  right: 0;
  top: 0px;
  z-index: 2;
  line-height: 60px;
  transition: 0.3s;
  min-width: 836px;
}
div#helpParamsPF {
  vertical-align: top;
  float: right;
  z-index: 2;
  margin: 10px 10px 0 0;
}
div#tableParamsPF {
  vertical-align: top;
  float: right;
  z-index: 2;
  margin: 10px 0 0 0;
}
</style>
